import { render, staticRenderFns } from "./AssessmentsList.vue?vue&type=template&id=63d9f1f1"
import script from "./AssessmentsList.vue?vue&type=script&lang=js"
export * from "./AssessmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports